<template>
  <div class="account-box">
    <!-- 已开通状态账户 -->
    <div v-if="isPass" class="account-item is-pass">
      <!-- 上方主体内容 -->
      <div class="item-header">
        <!-- 账户名 -->
        <div class="title">
          <div class="account-label">{{ data.invoiceCorpName }}</div>
          <div class="account-status">
            <div class="status-item">{{ data.accountStatus.statusStr }}</div>
          </div>
        </div>
        <!-- 总余额 -->
        <div class="total">
          <div class="total-content">
            <span class="number">
              <span class="unit">￥</span>
              {{ data.balance }}
            </span>
            <span class="tips">(余额)</span>
          </div>
        </div>
        <!-- 附加内容 -->
        <div class="attach">
          <ul class="attach-list">
            <li class="item">
              <span class="label">
                统一代码
              </span>
              <span class="content">{{ data.invoiceCorpCode }}</span>
            </li>
            <li class="item">
              <span class="label">税号</span
              ><span class="content">{{ data.invoiceCorpTaxNo }}</span>
            </li>
          </ul>
          <div class="btn-content">
            <div v-if="showOperateBtn(5041)" class="btn" @click="handleCharge">
              充值
            </div>
          </div>
        </div>
      </div>
      <!-- 主体内容 -->
      <div class="item-content">
        <!-- 明细 -->
        <ul class="details-list">
          <li class="detail-item">
            <div class="label">已申请运费</div>
            <div class="cost">
              <span class="value"
                ><span class="unit">￥</span>{{ data.freightClaimed }}</span
              >
            </div>
          </li>
          <li class="detail-item">
            <div class="label">已支付运费</div>
            <div class="cost">
              <span class="value"
                ><span class="unit">￥</span>{{ data.freightPaid }}</span
              >
            </div>
          </li>
          <li class="detail-item">
            <div class="label">已开票运费</div>
            <div class="cost">
              <span class="value"
                ><span class="unit">￥</span>{{ data.invoicedFreight }}</span
              >
            </div>
          </li>
        </ul>
        <!-- 操作按钮 -->
        <div class="handle-list">
          <ul class="handle-wrapper">
            <li
              v-if="showOperateBtn(5049, 'taxAccount')"
              class="btn"
              @click="handleJumpRoute('fundsDetail')"
            >
              资金明细
            </li>
            <li
              v-if="showOperateBtn(5042, 'taxAccount')"
              class="btn"
              @click="handleJumpRoute('rechargeRefund')"
            >
              充值扣款申请
            </li>
          </ul>
        </div>
      </div>
      <!-- 底部logo -->
      <div class="item-footer">
        <div class="bill-content">
          <div class="label">
            开票渠道
          </div>
          <img
            :src="require('e6-module-tax-service/assets/images/tax/logo.png')"
            class="logo"
            title="好多车"
            alt="好多车"
          />
        </div>
      </div>
    </div>
    <!-- 未开通状态账户 -->
    <div v-else class="account-item no-pass">
      <!-- 上方主体内容 -->
      <div class="item-header">
        <!-- 账户名 -->
        <div class="title">
          <div class="account-label">{{ data.invoiceCorpName }}</div>
          <div class="account-status">
            <div class="status-item">{{ data.accountStatus.statusStr }}</div>
          </div>
        </div>
        <!-- 附加内容 -->
        <div class="attach">
          <ul class="attach-list">
            <li class="item">
              <span class="label">
                统一代码
              </span>
              <span class="content">{{ data.invoiceCorpCode }}</span>
            </li>
            <li class="item">
              <span class="label">税号</span
              ><span class="content">{{ data.invoiceCorpTaxNo }}</span>
            </li>
          </ul>
        </div>
      </div>
      <!-- 主体内容 -->
      <div class="item-content">
        <!-- 未开通LOGO -->
        <div class="unregister-logo">
          <img
            class="unregister-img"
            :src="
              require('e6-module-tax-service/assets/images/tax/unregister.png')
            "
            alt=""
          />
        </div>
      </div>
      <!-- 底部logo -->
      <div class="item-footer">
        <div class="bill-content">
          <div class="label">
            开票渠道
          </div>
          <img
            :src="require('e6-module-tax-service/assets/images/tax/logo.png')"
            class="logo"
            title="好多车"
            alt="好多车"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import base from "e6-base-carrier-3.0/mixins/base";
export default {
  name: "AccountItem",
  mixins: [base],
  props: {
    // 账户信息
    data: {
      type: Object,
      require: true
    }
  },
  data() {
    return {};
  },
  computed: {
    // 账户状态已开通
    isPass() {
      return this.accountStatus === 2;
    },
    // 账户状态
    accountStatus() {
      return (
        (this.data && this.data.accountStatus && this.data.accountStatus.id) ||
        1
      );
    },
    // 账号ID
    accountId() {
      return (this.data && this.data.corpAccountId) || null;
    }
  },
  methods: {
    // 点击充值事件
    handleCharge() {
      // 打开充值弹窗
      this.$emit("charge", { corpAccountId: this.accountId });
    },
    // 跳转路由
    handleJumpRoute(routeName) {
      // 跳转时，传递 账户ID和渠道ID 参数
      const { supplierInfo } = this.data;
      this.routerPush({
        name: routeName,
        params: {
          refresh: true
        },
        query: {
          supplierId: supplierInfo.id || "",
          corpAccountId: this.accountId
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~e6-base-carrier-3.0/styles/variables";
@import "~e6-base-carrier-3.0/styles/utils";
.account-item {
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  background-color: #fff;
  overflow: hidden;
  box-shadow: 0 6px 20px -6px rgba(0, 0, 0, 0.1);
  // 账户头部
  .item-header {
    padding: 15px;
    color: #fff;
    background: linear-gradient(140deg, #5fd4fe, #5dadff);
    // 账户名
    .title {
      @include utils-clearfix;
      .account-label {
        @include utils-ellipsis;
        float: left;
        width: 70%;
        font-size: 18px;
      }
      .account-status {
        float: left;
        width: 30%;
        .status-item {
          @include utils-ellipsis;
          max-width: 100%;
          float: right;
          padding: 3px 6px;
          border-radius: 9px;
          box-sizing: border-box;
          font-size: 12px;
          color: #3095fd;
          background-color: #9edaff;
        }
      }
    }
    // 余额总数
    .total {
      position: relative;
      top: 0;
      left: 0;
      height: 40px;
      margin-top: 20px;
      .total-content {
        position: absolute;
        top: 0;
        left: 47%;
        transform: translate(-50%, 0);
        .number {
          @include utils-ellipsis;
          max-width: 210px;
          display: inline-block;
          font-size: 30px;
          font-family: arial;
          .unit {
            position: absolute;
            left: -14px;
            top: 11px;
            font-size: 18px;
          }
        }
        .tips {
          position: absolute;
          right: -38px;
          top: 15px;
          font-size: 12px;
        }
      }
    }
    // 附加内容
    .attach {
      display: flex;
      .attach-list {
        flex: 1;
        font-size: 12px;
        .item {
          margin-bottom: 4px;
          display: flex;
          .label {
            margin-right: 8px;
          }
          .content {
            @include utils-ellipsis;
            flex: 1;
            max-width: 140px;
          }
        }
      }
      .btn-content {
        width: 50px;
        .btn {
          width: 50px;
          height: 25px;
          border-radius: 4px;
          text-align: center;
          line-height: 25px;
          border: 1px solid #fff;
          font-size: 12px;
          box-sizing: border-box;
          cursor: pointer;
        }
      }
    }
  }
  // 账户主体
  .item-content {
    flex: 1;
    padding: 15px;
    font-size: 12px;
    // 金额明细
    .details-list {
      .detail-item {
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;
        .label {
          min-width: 80px;
          color: #898c91;
        }
        .cost {
          @include utils-ellipsis;
          flex: 1;
          text-align: right;
          font-family: Arial;
          .value {
            position: relative;
            top: 0;
            left: 0;
            color: #48494c;
            .unit {
              position: absolute;
              left: -10px;
              top: 1px;
              color: #898c91;
            }
          }
        }
      }
    }
    // 操作按钮
    .handle-list {
      .handle-wrapper {
        float: right;
        .btn {
          float: left;
          margin-left: 10px;
          color: #849bbd;
          cursor: pointer;
        }
      }
    }
  }
  // 账号底部
  .item-footer {
    flex-basis: 40px;
    padding: 0 15px;
    height: 40px;
    background-color: #f5f7fa;
    .bill-content {
      float: right;
      display: flex;
      height: 100%;
      .label {
        font-size: 12px;
        line-height: 40px;
        color: #898c91;
      }
      .logo {
        width: 90px;
        height: 20px;
        margin-top: 8px;
        margin-left: 6px;
      }
    }
  }
  // 未开通账户
  &.no-pass {
    .item-header {
      background: #f9fafc;
      color: #adb1b8 !important;
      .title {
        .account-status {
          .status-item {
            background-color: #e0eefd;
          }
        }
      }
      .attach {
        margin-top: 15px;
      }
    }
    .item-content {
      background: #f9fafc;
      .unregister-logo {
        position: relative;
        left: 0;
        top: 0;
        width: 100%;
        height: 139px;
        .unregister-img {
          position: absolute;
          left: 50%;
          top: 35%;
          transform: translate(-50%, -50%);
        }
      }
    }
  }
}
</style>
